var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-form flex col-2" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.innerNo))])
        ])
      ]),
      _vm._v(" "),
      _vm.transVoucherInfo.srcVoucherType != null
        ? _c("div", { staticClass: "form-group center" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.srcVoucherNo))])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.outerNo || "无"))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.srcBizUnitName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.dstBizUnitName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.transVoucherInfo.memo))])
        ])
      ])
    ]),
    _vm._v(" "),
    _vm._m(6),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            ref: "multipleTable",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.returnVoucherList,
              maxHeight: "500",
              border: "",
              "tooltip-effect": "dark"
            }
          },
          [
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "innerNo",
                label: "自有退还单号",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "srcVoucherInnerNo",
                label: "原调拨单号",
                width: "180",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "dstBizUnitName",
                label: "申请部门",
                width: "280",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "srcBizUnitName",
                label: "调出部门",
                width: "280",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                label: "完成状态",
                width: "100",
                "show-overflow-tooltip": ""
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.confirmState == 1
                        ? _c("span", { staticClass: "font-green" }, [
                            _vm._v("已完成")
                          ])
                        : _c("span", { staticClass: "font-red" }, [
                            _vm._v("未完成")
                          ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "confirmTime",
                label: "确认时间",
                width: "180",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "confirmerName",
                label: "确认人",
                width: "180",
                "show-overflow-tooltip": ""
              }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "simple-row" }, [
      _c(
        "div",
        { staticClass: "left" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  _vm.selectDevice()
                }
              }
            },
            [_vm._v("选择调拨项")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            ref: "multipleTable",
            staticStyle: { width: "100%" },
            attrs: {
              data: _vm.itemList,
              maxHeight: "500",
              border: "",
              "tooltip-effect": "dark"
            }
          },
          [
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "title",
                label: "资产描述全称",
                fixed: "",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "model",
                label: "型号",
                fixed: "",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                prop: "fixedSpec",
                label: "规格",
                fixed: "",
                "show-overflow-tooltip": ""
              }
            }),
            _vm._v(" "),
            _c(
              "el-table-column",
              { attrs: { label: "资产基础信息", align: "center" } },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "name",
                    "min-width": "150",
                    label: "名称",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "tmpNo",
                    "min-width": "250",
                    label: "系统编号",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "innerCode",
                    "min-width": "250",
                    label: "资产编号",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "catName",
                    width: "100",
                    label: "分类",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "groupName",
                    width: "120",
                    label: "维保分组",
                    "show-overflow-tooltip": ""
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getGoodsCatDevcGroupName(rows.row.catId)
                              )
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "brandName",
                    width: "150",
                    label: "品牌",
                    "show-overflow-tooltip": ""
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    prop: "assetKindName",
                    label: "财务类别",
                    width: "150",
                    align: "left",
                    "show-overflow-tooltip": ""
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table-column",
              { attrs: { label: "调拨信息", align: "center" } },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "srcComFullName",
                    width: "100",
                    label: "调出部门全称"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    prop: "srcWarehouseName",
                    width: "100",
                    label: "调出仓库"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "directQuantity",
                    width: "100",
                    label: "退还数量"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "receiptQuantity",
                    width: "100",
                    label: "验收数量"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "transQuantity",
                    width: "100",
                    label: "调拨数量"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "quantity",
                    label: "退还数量",
                    width: "80"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(scope) {
                        return [
                          _c("el-input", {
                            staticClass: "input-content-right",
                            attrs: { type: "number", min: "0", disabled: true },
                            on: {
                              change: function($event) {
                                _vm.transAvQuantityChange(scope)
                              }
                            },
                            model: {
                              value: scope.row.quantity,
                              callback: function($$v) {
                                _vm.$set(scope.row, "quantity", _vm._n($$v))
                              },
                              expression: "scope.row.quantity"
                            }
                          })
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table-column",
              { attrs: { label: "附加信息", align: "center" } },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "theUnit",
                    "min-width": "100",
                    label: "单位"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-table-column",
              { attrs: { label: "资产价值", align: "center" } },
              [
                _c("el-table-column", {
                  attrs: {
                    align: "left",
                    "min-width": "100",
                    label: "入账方式"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.acctEnterWayMap[rows.row.acctEnterWay])
                            )
                          ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "orgWorth",
                    width: "80",
                    label: "原值(元)"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.orgWorth != null
                            ? _c("span", [
                                _vm._v(_vm._s(rows.row.orgWorth.toFixed(2)))
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    prop: "netWorth",
                    width: "80",
                    label: "净值(元)"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.netWorth != null
                            ? _c("span", [
                                _vm._v(_vm._s(rows.row.netWorth.toFixed(2)))
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调拨单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("来源单据号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("外部单据号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调出机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("调入机构")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content-caption dashed" }, [
      _c("span", [_vm._v("退还调拨单")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16e89383", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16e89383","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/transVoucher/ShopDeviceTransVoucherReturnSave.vue
// module id = 2535
// module chunks = 0